export class StaffMemberFormModel {
  constructor(member = {}) {
    this.email = member?.email || "";
    this.firstName = member?.firstName || "";
    this.lastName = member?.lastName || "";
    this.contactNumber = member?.contactNumber || "";
    this.role = member?.role || "";
  }
}
